// SEO slug for a part — must match backend slug_service.part_slug exactly.
const slugify = (...parts) => {
  const pieces = [];
  for (const p of parts) {
    if (!p && p !== 0) continue;
    let s = String(p).toLowerCase().trim();
    s = s.normalize("NFKD").replace(/[\u0300-\u036f]/g, ""); // strip diacritics
    s = s.replace(/[^a-z0-9]+/g, "-").replace(/(^-+|-+$)/g, "");
    if (s) pieces.push(s);
  }
  let raw = pieces.join("-").replace(/-{2,}/g, "-").replace(/(^-+|-+$)/g, "");
  const words = raw.split("-");
  if (words.length > 12) raw = words.slice(0, 12).join("-");
  return raw;
};

export const partSlug = (part) => {
  if (!part) return "";
  const base = slugify(
    part.year_from || part.year_to || "",
    part.make,
    part.model,
    part.name,
  );
  const short = (part.id || "").replace(/-/g, "").slice(0, 4) || "part";
  return base ? `${base}-${short}` : short;
};
